import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/transform", label: "Transform" },
  { to: "/read", label: "Read" },
  { to: "/listen", label: "Listen" },
  { to: "/belong", label: "Belong" },
  { to: "/invite", label: "Invite" },
  { to: "/assessment", label: "LifePrints™" },
  { to: "/blade-grain", label: "Blade & Grain" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#FAF4E9]/95 backdrop-blur-md border-b border-[#21302A]/10 py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="font-serif-d text-xl tracking-tight text-[#1E3A2B] leading-none">
          Life With <span className="italic-emph text-[#C0953A]">Nata</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g,'')}`}
              className="text-xs uppercase tracking-[0.18em] text-[#21302A] hover:text-[#C0953A] transition-colors link-underline">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          {user ? (
            <button data-testid="nav-dashboard-btn" onClick={() => nav("/dashboard")}
              className="bg-[#1E3A2B] text-[#FAF4E9] hover:bg-[#2E5240] transition-colors px-6 py-3 uppercase tracking-widest text-xs font-medium">
              Dashboard
            </button>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn" className="text-xs uppercase tracking-[0.18em] text-[#21302A] hover:text-[#C0953A]">Log In</Link>
              <Link to="/signup" data-testid="nav-signup-btn"
                className="bg-[#1E3A2B] text-[#FAF4E9] hover:bg-[#2E5240] transition-colors px-6 py-3 uppercase tracking-widest text-xs font-medium">
                Join
              </Link>
            </>
          )}
        </div>

        <button data-testid="mobile-menu-btn" className="lg:hidden text-[#1E3A2B]" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FAF4E9] border-t border-[#21302A]/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-[#21302A]">{l.label}</Link>
          ))}
          {user ? (
            <Link to="/dashboard" onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-[#C0953A]">Dashboard</Link>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-[#21302A]">Log In</Link>
              <Link to="/signup" onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-[#C0953A]">Join</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};
